import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {PullRequestErrorState} from '../components/PullRequestErrorState'
import {SplitPageLayout} from '@primer/react'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {PullRequestFileTree} from '@github-ui/pull-request-file-tree/PullRequestFileTree'
import {PullRequestFilesToolbar} from '@github-ui/pull-request-files-toolbar/PullRequestFilesToolbar'
import {getDiffsPageData} from '../test-utils/diffs-mock-data'
import {PullRequestDiffsList} from '../components/PullRequestDiffsList'
import type {FilesRoutePayload} from '../page-data/payloads/files'

export function FilesEntrypoint() {
  return (
    <ErrorBoundary critical fallback={<PullRequestErrorState text="Changes cannot be loaded" />}>
      <Files />
    </ErrorBoundary>
  )
}

export function Files() {
  const data = useRoutePayload<FilesRoutePayload>()

  return <FilesComponent {...data} />
}

export function FilesComponent(payload: FilesRoutePayload) {
  const {annotations, commits, diffs, pullRequest, repository, threadPreviews, user, viewerPendingReview} = payload

  // TODO: get diffs from the API
  const diffsEntries = getDiffsPageData()

  return (
    <>
      <SplitPageLayout.Pane
        position="start"
        divider="none"
        sticky
        offsetHeader="80px" // sticky header height + a lil extra for spacing
        aria-label="File tree"
        padding="none"
        className="pr-3"
      >
        <PullRequestFileTree
          baseRefOid={pullRequest.comparison.baseOid}
          commits={commits}
          diffs={diffs}
          ownerLogin={repository.ownerLogin}
          pathName={pullRequest.pathName}
          pullRequestId={pullRequest.globalRelayId}
          pullRequestNumber={pullRequest.number}
          repositoryName={repository.name}
        />
      </SplitPageLayout.Pane>
      <SplitPageLayout.Content as="div" width="full" padding="none">
        <PullRequestFilesToolbar
          annotations={annotations}
          copilotAccessAllowed={repository.copilotEnabled}
          currentUserLogin={user.currentUserLogin}
          isFileTreeExpanded={user.isFileTreeExpanded}
          pullRequest={pullRequest}
          repository={repository}
          shouldShowViewedFilesCount={user.shouldShowViewedFilesCount}
          totalFilesCount={diffs.length}
          threadPreviews={threadPreviews}
          viewedFilesCount={user.viewedFilesCount}
          viewerPendingReview={viewerPendingReview}
          viewSettings={user.viewSettings}
        />
        <PullRequestDiffsList diffs={diffsEntries} />
      </SplitPageLayout.Content>
    </>
  )
}

try{ FilesEntrypoint.displayName ||= 'FilesEntrypoint' } catch {}
try{ Files.displayName ||= 'Files' } catch {}
try{ FilesComponent.displayName ||= 'FilesComponent' } catch {}